import actions from './actions';

const {
  CREATE_JOB_BEGIN,
  CREATE_JOB_SUCCESS,
  CREATE_JOB_ERR,

  JOBS_READ_BEGIN,
  JOBS_READ_SUCCESS,
  JOBS_READ_ERR,
  JOBS_READ_LENGTH,

  JOBS_STATS_BEGIN,
  JOBS_STATS_SUCCESS,
  JOBS_STATS_ERR,

  GET_JOB_BEGIN,
  GET_JOB_SUCCESS,
  GET_JOB_ERR,

  GET_FILTERS_BEGIN,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_ERR,

  CANCEL_JOB_BEGIN,
  CANCEL_JOB_SUCCESS,
  CANCEL_JOB_ERR,

  DELETE_JOB_BEGIN,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_ERR,

  UPDATE_JOB_FILTER,
} = actions;

const initialState = {
  filters: {},
  jobs: [],
  jobsLength: 0,
  job: [],
  data: {},
  loading: false,
  error: null,

  statsLoading: false,
  statsErr: false,
  stats: {},

  getJobLoading: false,
  getJob: {},
  getJobErr: false,

  getFilterLoading: false,
  getFilterData: {},
  getFilterErr: false,

  cancelJobLoading: false,
  cancelJobData: {},
  cancelJobErr: false,

  deleteJobLoading: false,
  deleteJobData: {},
  deleteJobErr: false,
};

const JobSearchReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_JOB_BEGIN:
      return {
        ...state,
        data: {},
        error: null,
        loading: true,
      };
    case CREATE_JOB_SUCCESS:
      return {
        ...state,
        error: null,
        data,
        loading: false,
      };
    case CREATE_JOB_ERR:
      return {
        ...state,
        data: {},
        error: err,
        loading: false,
      };
    case JOBS_READ_BEGIN:
      return {
        ...state,
        jobs: [],
        error: null,
        loading: true,
      };
    case JOBS_READ_SUCCESS:
      return {
        ...state,
        jobs: data,
        error: null,
        loading: false,
      };
    case JOBS_READ_ERR:
      return {
        ...state,
        jobs: [],
        error: err,
        loading: false,
      };
    case JOBS_READ_LENGTH:
      return {
        ...state,
        jobsLength: data,
      };
    case JOBS_STATS_BEGIN:
      return {
        ...state,
        statsLoading: true,
        statsErr: false,
        stats: [],
      };
    case JOBS_STATS_SUCCESS:
      return {
        ...state,
        statsLoading: false,
        statsErr: false,
        stats: data,
      };
    case JOBS_STATS_ERR:
      return {
        ...state,
        statsLoading: false,
        statsErr: true,
        stats: [],
      };
    case GET_FILTERS_BEGIN:
      return {
        ...state,
        getFilterLoading: true,
        getFilterErr: false,
        getFilterData: {},
      };
    case GET_FILTERS_SUCCESS:
      return {
        ...state,
        getFilterLoading: false,
        getFilterErr: false,
        getFilterData: data,
      };
    case GET_FILTERS_ERR:
      return {
        ...state,
        getFilterLoading: false,
        getFilterErr: true,
        getFilterData: {},
      };
    case GET_JOB_BEGIN:
      return {
        ...state,
        getJob: {},
        getJobErr: false,
        getJobLoading: true,
      };
    case GET_JOB_SUCCESS:
      return {
        ...state,
        getJob: data,
        getJobLoading: false,
      };
    case GET_JOB_ERR:
      return {
        ...state,
        getJobErr: err,
        getJobLoading: false,
      };
    case CANCEL_JOB_BEGIN:
      return {
        ...state,
        cancelJob: {},
        cancelJobErr: false,
        cancelJobLoading: true,
      };
    case CANCEL_JOB_SUCCESS:
      return {
        ...state,
        cancelJob: data,
        cancelJobLoading: false,
      };
    case CANCEL_JOB_ERR:
      return {
        ...state,
        cancelJobErr: err,
        cancelJobLoading: false,
      };
    case DELETE_JOB_BEGIN:
      return {
        ...state,
        deleteJob: {},
        deleteJobErr: false,
        deleteJobLoading: true,
      };
    case DELETE_JOB_SUCCESS:
      return {
        ...state,
        deleteJob: data,
        deleteJobLoading: false,
      };
    case DELETE_JOB_ERR:
      return {
        ...state,
        deleteJobErr: err,
        deleteJobLoading: false,
      };
    case UPDATE_JOB_FILTER:
      return {
        ...state,
        filters: { ...data },
      };
    default:
      return state;
  }
};

export default JobSearchReducer;
